// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.Reports.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';

import connect from 'share/enhancers/Izenda.Connect';
import uiState from 'logic/Izenda.UiState';
import m from 'mobx';
import Sidebar from 'share/components/layout/Izenda.Sidebar';
import ReportLeftNavigation from './Izenda.ReportLeftNavigation';
import MainContent from 'share/components/layout/Izenda.MainContent';
import MainWrapper from 'share/components/layout/Izenda.MainWrapper';
import SettingsLevel from 'modules/Settings/SettingsLevel/Izenda.SettingsLevel';
import SettingsStore from 'logic/Izenda.SettingsStore';
import routeUtils from 'share/utils/Izenda.RouteUtils';
import { isEmpty, isNil, get } from 'lodash/fp';

@connect()
export default class Reports extends Component {
  constructor(props) {
    super(props);
  }

  static propTypes = {
    store: PropTypes.object.isRequired
  };

  componentWillMount() {
    this.settingStore = new SettingsStore(true);
  }

  componentDidMount() {
    var props = this.props;
    var store = this.props.store;

    // observe changing tenantId, then reload data for Reports
    this.disposeObserveTenantId = m.observe(uiState, 'tenantId', () => {
      if (uiState.silentUpdate) return;
      !uiState.keepState &&
        props.router.push({
          pathname: routeUtils.getReportUrl()
        });
    });

    this.enableSystemSetting(props);
  }

  componentWillReceiveProps(nextProps) {
    if (isEmpty(nextProps.params) && nextProps.params !== this.props.params) {
      this.props.store.resetModel();
    }

    this.enableSystemSetting(nextProps);
  }

  componentWillUnmount() {
    this.disposeObserveTenantId();
    this.settingStore.destroy();
  }

  /**
   * Enable system setting level base on report viewer or report list
   * @param  {Object} props Component props
   */
  enableSystemSetting = (props: Object): void => {
    // disable system setting on report viewer mode
    if (!isNil(props.params.id)) {
      uiState.updateDisableSystemSetting();
    } else {
      uiState.enableSystemSetting();
    }
  };

  render() {
    const props = this.props;
    const { store, params, children, reportSubscriptionStore } = props;
    const hasNewCategory = get('model.hasNewCategory', store);
    const isIframeExported = routeUtils.checkIframeExported();
    const reportType = !isNil(params) && !isNil(params.reportType) ? params.reportType : '0';
    // Only show report left navigate on report list and disable system lvl
    const showReportLeftNavigate = isNil(params.id);

    return (
      <section className="izenda-Reports">
        { !isIframeExported && (
          <SettingsLevel store={this.settingStore} />
        )}

        <MainWrapper settingStore={this.settingStore}>
          <div className="izenda-TableLayout u_paddingTopBottom">
            {showReportLeftNavigate && (
              <Sidebar className="izenda-Content-Sidebar" hasScrollBox={false}>
                <ReportLeftNavigation
                  store={store}
                  reportType={reportType}
                  isReload={isEmpty(params) || hasNewCategory}
                />
              </Sidebar>
            )}
            <MainContent>
              {children &&
                React.cloneElement(children, {
                  store,
                  reportSubscriptionStore: reportSubscriptionStore
                })}
            </MainContent>
          </div>
        </MainWrapper>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Reports/Izenda.Reports.js